export interface OrganizationLoadError { kind: 'forbidden' | 'missing' | 'failed'; message: string; retryable: boolean; }
export function organizationLoadError(error: unknown): OrganizationLoadError {
    const status = error && typeof error === 'object' && 'status' in error ? Number(error.status) : 0;
    if (status === 401 || status === 403 || status === 422) return {
        kind: 'forbidden', message: 'You do not have access to this organization.', retryable: false,
    };
    if (status === 404) return { kind: 'missing', message: 'This organization could not be found.', retryable: false };
    return { kind: 'failed', message: 'Could not load organization information. Please try again.', retryable: true };
}
